import { render, staticRenderFns } from "./LocationWiseStock.vue?vue&type=template&id=3a50126d"
import script from "./LocationWiseStock.vue?vue&type=script&lang=js"
export * from "./LocationWiseStock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports